import { all, fork, spawn } from 'redux-saga/effects';

import { auth } from './auth/actions';
import { users } from './users/actions';
import { profile } from './profile/actions';
import { orders } from './orders/actions';
import { videos } from './videos/actions';
import { market } from './market/actions';
import { transfer } from './transfer/actions';
import { wallets } from './wallets/actions';
import { referrals } from './referrals/actions';
import { admins } from './admins/actions';
import { projects } from './projects/actions';
import { vacancies } from './vacancies/actions';
import { traderInfos } from './traderInfo/actions';
import { settings } from './settings/actions';
import { fiatTransfer } from './fiatTransfer/actions';
import { reset2FA } from './reset2FA/actions';
import { cashbacks } from './cashback/actions';
import { feesAndLimits } from './feesAndLimits/actions';
import { tradeVolumeSettings } from './tradeVolumeSettings/actions';
import { trades } from './trades/actions';
import { chatModerators } from './chatModerators/actions';
import { posts } from './posts/actions';
import { vote } from './vote/actions';

export default function* rootSaga() {
  yield all([
    spawn(auth),
    spawn(users),
    spawn(profile),
    spawn(orders),
    spawn(videos),
    spawn(market),
    spawn(transfer),
    spawn(fiatTransfer),
    spawn(wallets),
    spawn(referrals),
    spawn(admins),
    spawn(projects),
    spawn(vacancies),
    spawn(traderInfos),
    spawn(settings),
    spawn(reset2FA),
    spawn(cashbacks),
    spawn(feesAndLimits),
    spawn(tradeVolumeSettings),
    spawn(trades),
    spawn(chatModerators),
    spawn(posts),
    spawn(vote),
  ]);
}
